import { render, staticRenderFns } from "./ItemAdditionalPerson.vue?vue&type=template&id=0de16ae6&"
import script from "./ItemAdditionalPerson.vue?vue&type=script&lang=ts&"
export * from "./ItemAdditionalPerson.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VDivider,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0de16ae6')) {
      api.createRecord('0de16ae6', component.options)
    } else {
      api.reload('0de16ae6', component.options)
    }
    module.hot.accept("./ItemAdditionalPerson.vue?vue&type=template&id=0de16ae6&", function () {
      api.rerender('0de16ae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tickets/tickets-form/access/ItemAdditionalPerson.vue"
export default component.exports